import loadable from '@loadable/component';

export const CmsThreeStepCtaBlockLoadable = loadable(
  () => import('./CmsThreeStepCtaBlock'),
  { resolveComponent: (module) => module.CmsThreeStepCtaBlock },
);
